import {EnvironmentMode} from '@shared/constants/environment-mode.enum';

export const environment = {
  production: true,
  baseUrl: 'https://scapis2-server-edu.it.gu.se/scapis2',
  environmentString: EnvironmentMode.EDU
};
